<template>
  <div>
    <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition"
      v-model="snackbar" timeout="2000" :value="true" :color="snaclr" absolute outlined top right>
      <v-icon class="mr-2" :color="snaclr">mdi-alert-outline</v-icon>
      {{ snackmsgbar }}
    </v-snackbar>


    <div class="ml-14 mr-14 mt-14">
      <v-card elevation="0" class=" pa-1">
        <v-toolbar dense class="elevation-0 pl-0 ">
          <v-toolbar-title class="font-weight-bold title ml-0 mt-2">
            Client Account Closing
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon class="d-none" @click="downloadExcel">mdi-download</v-icon>


          <div class="ml-3">
            <v-text-field dense solo flat label="Search " outlined class="  elevation-0 rounded-lg" v-model="tabledata"
              hide-details prepend-inner-icon="mdi-magnify" style="max-width: 200px"></v-text-field>
          </div>
          <!-- <div class="ml-3">
            <v-select dense hide-details :items="['All', 'success']" style="max-width: 100px"></v-select>
          </div> -->
          <!-- <div class="ml-2"><v-btn color="warning" icon><v-icon>mdi-download</v-icon></v-btn></div> -->
        </v-toolbar>
        <v-divider class="mt-3"></v-divider>
        <!-- <div class="stat d-flex mt-7">
          <v-card class="card text-center elevation-0 ">
            <p class="font-weight-regular mt-5 mb-0">Total Clients</p>
            <p class="mt-0 font-weight-bold mt-1">{{ totalClients }}</p>
          </v-card>
          <v-card class="card text-center elevation-0">
            <p class="font-weight-regular mt-5 mb-0">Updated Clients</p>
            <p class="font-weight-bold mt-1">{{ updatedClients }}</p>
          </v-card>
          <v-card class="card text-center elevation-0">
            <p class="font-weight-regular mt-5 mb-0">Pending Clients</p>
            <p class="font-weight-bold mt-1">{{ notUpdatedClients }}</p>
          </v-card>
        </div> -->
        <v-data-table :search="tabledata" :loading="tableload" :headers="headers" :items="dispayadmindat"
          class="brd elevation-0 mt-7" disable-sort outlined>
          <template v-slot:[`item.satupate`]="{ item }">
              <div class="d-flex justify-space-between align-center" >
                
               <p class="ma-0">{{ item.branch_status }}</p>
              
            <v-btn v-if="item.branch_status == '' || item.branch_status == null" small color="primary"
              @click="confirnfun(item)" rounded elevation="0" class="text-none white--text mx-auto">
              Update
            </v-btn>
            
            <v-tooltip v-else bottom content-class="tclr">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="black" class="cursor-pointer ml-2" size="22">
                  mdi-information-slab-circle-outline
                </v-icon>
              </template>

              <span v-if="item.branch_feedback">Reason: {{ item.branch_feedback }}</span>
              <p>Date & Time: {{ item.date_time }}</p>
            </v-tooltip>
            </div>
          </template>

          <template v-slot:[`item.app_status1`]="{ item }">
            <div class="d-flex align-center">
              <p class="ma-0">{{ item.app_status }}</p>

              <v-tooltip v-if="item.app_status === 'approved' || item.app_status === 'rejected'" bottom content-class="tclr">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" color="black" class="cursor-pointer ml-2" size="20">
                    mdi-information-slab-circle-outline
                     <!-- mdi-information-symbol -->
                  </v-icon>
                </template>
                <div v-if="item.app_status === 'approved'">
                <p class="mb-0">Approval time:<br>
                  {{ item.approval_date_time }}</p>
                </div>
                <div v-if="item.app_status === 'rejected'">
                <p class="mb-0">Rejected Reason: {{ item.rejected_reason }}</p>
                <p>Rejected Date:{{ item.rejection_date_time }}</p>

                  </div>
                
              </v-tooltip>
              
            </div>
          </template>




        </v-data-table>

        <v-dialog v-model="dialog" persistent max-width="490">
          <v-card outlined elevation="0" class="pa-4 rounded-lg">
            <p class="mb-0 font-weight-bold subtitle-1">Closer Status Update - ({{ dialogdata.client_id ?
              dialogdata.client_id :
              '' - dialogdata.client_name ? dialogdata.client_name : '' }})</p>
            <!-- <p class="mb-1 font-weight-semibold subtitle-1">Client Id - Z51875</p>
            <p class="mb-1 font-weight-semibold subtitle-1">Client Name - Z51875</p> -->
            <p class="mt-2 mb-1 font-weight-semibold subtitle-2">Select the Status</p>
            <v-select v-model="clistatus" outlined class="mt-0" hide-details :items="['Approved', 'Retained']"
              placeholder="Select the Status" dense></v-select>
            <p class="mt-4 mb-1 font-weight-semibold subtitle-2">Client Feedback</p>
            <v-textarea v-model="clifeedback" rows="2" outlined class="mt-0" hide-details placeholder="Client Feedback"
              dense></v-textarea>
            <v-row class="mt-5">
              <v-col cols="6">
                <v-btn block @click="dialog = false" color="#F1F3F8" :disabled="orderloader"
                  class="text-none rounded-pill elevation-0 subtext--text px-6" height="40px">
                  Cancel </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn @click="statusupdateapi()" color="black" :loading="orderloader"
                  :disabled="orderloader || clistatus == '' || clifeedback == ''" block
                  class="text-none rounded-pill elevation-0 white--text subtext--text px-6" height="40px"> Submit
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </div>
</template>


<script>
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
  data() {
    return {
      dialog: false,
      tabledata: "",
      headers: [
        {
          text: ' E-sign Date & Time',
          align: 'start',
          value: 'date_time',
        },
        { text: 'Client Id', value: 'client_id' },
        { text: 'Client Name', value: 'client_name' },
        { text: 'DP Code', value: 'dp_code' },
        // { text: 'E-sign Status', value: 'app_status' },
        { text: 'Client Reason', value: 'reason' },
        { text: 'Application Status', value: 'app_status1' },
        // { text: 'Status', value: 'branch_status' },
        { text: 'Branch Status', value: 'satupate' },


      ],
      dispayadmindat: [],
      snackbar: false,
      snackmsgbar: "",
      snaclr: "#000",
      tableload: true,
      dialogdata: [],
      clifeedback: "",
      clistatus: "",
      orderloader: false
    }

  },
  // computed: {
  //   totalClients() {
  //     return this.dispayadmindat.length;
  //   },
  //   updatedClients() {
  //     return this.dispayadmindat.filter(item => item.branch_status === '').length;
  //   },
  //   notUpdatedClients() {
  //     return this.dispayadmindat.filter(item => item.branch_status !== '').length;
  //   }
  // },
  methods: {
    lumsunresdata() {
      this.tableload = true
      this.dispayadmindat = []
      const axios = require('axios');
      let data = JSON.stringify({
        "branch_id": localStorage.getItem("brcode")

      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://rekycbe.mynt.in/closure_branch',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      var axiosThis = this
      axios.request(config)
        .then((response) => {
          axiosThis.tableload = false
          if (response.data.stat == "Ok") {
            axiosThis.dispayadmindat = response.data.data
          } else {
            axiosThis.snackbar = true
            axiosThis.snackmsgbar = response.data
            axiosThis.snaclr = "error"
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.tableload = false
          axiosThis.snackbar = true
          axiosThis.snackmsgbar = error
          axiosThis.snaclr = "error"
        });

    },
    downloadExcel() {

      const dataForExcel = this.dispayadmindat.map(item => {
        return {
          "E-sign Date & Time": item.date_time,
          "Client Id": item.client_id,
          "Client Name": item.client_name,
          "DP Code": item.dp_code,
          "E-sign Status": item.app_status,
          "Client Reason": item.reason,
          "Status": item.branch_status,
          "Status Update Date & time": item.branch_status_datetime,
          "Branch Feedback": item.branch_feedback,
        };
      });
      const worksheet = XLSX.utils.json_to_sheet(dataForExcel);

      // Create a new workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Write workbook and convert to Blob
      const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], { type: "application/octet-stream" });


      saveAs(blob, "account-exit-data.xlsx");
    },
    confirnfun(item) {
      this.dialogdata = item
      this.dialog = true
    },
    statusupdateapi() {
      this.orderloader = true
      const axios = require('axios');
      let data = JSON.stringify({
        "branch_id": localStorage.getItem("brcode"),
        "status": this.clistatus == 'Retained' ? 'rejected' : this.clistatus.toLowerCase(),
        "feedback": this.clifeedback,
        "client_id": this.dialogdata.client_id,
        "log": {
          "details": localStorage.getItem("email")
        }

      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://rekycbe.mynt.in/closure_branch_update',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      var axiosThis = this

      axios.request(config)
        .then((response) => {
          console.log(JSON.stringify(response.data));
          axiosThis.orderloader = false
          axiosThis.dialog = false
          if (response.data.stat == 'Ok') {
            axiosThis.snackbar = true;
            axiosThis.snaclr = "green";
            axiosThis.snackmsgbar = response.data.msg;
            axiosThis.lumsunresdata()
            // axiosThis.allordersdata()
          }
          else {
            axiosThis.snackbar = true;
            axiosThis.snaclr = "error";
            axiosThis.snackmsgbar = response.data;
            console.log("else ");

          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.orderloader = false
          axiosThis.snackbar = true;
          axiosThis.snaclr = "error";
          axiosThis.snackmsgbar = error
          axiosThis.dialog = false


        });

    }
  },

  mounted() {
    this.lumsunresdata()
  }

}

</script>
<style scoped>
.brd {
  border: 1px solid #E0E0E0;
}

.tclr {
  background-color: black !important;
}

.stat {
  gap: 5px;
  justify-content: space-evenly;
}

.card {

  height: 90px;
  width: 400px;
  border: 1px solid #E0E0E0;
  border-radius: 10px;

}
</style>